import * as React from "react";
import type { SVGProps } from "react";
const SvgMenuIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="menu_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M128 256a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 256zm0 256a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 512zm42.667 213.333a42.667 42.667 0 1 0 0 85.334h682.666a42.667 42.667 0 1 0 0-85.334H170.667z"
    />
  </svg>
);
export default SvgMenuIcon;
